import {
  EAnalyticsLoggerActions,
  EAnalyticsLoggerEventNames,
  EAnalyticsLoggerEvents,
  EAnalyticsLoggerItemType,
} from '../types';
import { caseFactory } from '../utils';

export const accreditationTabsNavigation = caseFactory({
  name: EAnalyticsLoggerEventNames.AccreditationTabsNavigation,
})
  .event(EAnalyticsLoggerEvents.Navigation)
  .action(EAnalyticsLoggerActions.ClickButton)
  .itemType(EAnalyticsLoggerItemType.Company);
